import { Box, Container, Grid } from "@mui/material";
import React from "react";
import Img1 from "./../assets/images/nexen/nexen_first.jpg";
import Img2 from "./../assets/images/nexen/nexen_second.jpg";
import Img3 from "./../assets/images/nexen/nexen_third.jpg";
import Img4 from "./../assets/images/nexen/nexen_four.jpg";
import Img5 from "./../assets/images/nexen/nexen_five.jpg";
import Img6 from "./../assets/images/nexen/nexen_six.jpg";
import Img7 from "./../assets/images/nexen/nexen_seven.jpg";
import Img8 from "./../assets/images/nexen/nexen_eight.jpg";
import Img9 from "./../assets/images/nexen/nexen_nine.jpg";

import Project_first from "./../assets/images/projectsImages/IMG_6229_edited.jpg";
import Project_second from "./../assets/images/projectsImages/1.jpg";
import Project_third from "../assets/images/relatedprojects/pembina.jpg";
import Project_four from "../assets/images/relatedprojects/cenovus.jpg";

import Contentimages from "../components/Contentimages";
import ProtfolioNavigation from "../components/ProtfolioNavigation";
import RelatedProjects from "../components/RelatedProjects";
import { useDocumentMetaData } from "../components/useDocumentMetaData";

const Nexenwellness = () => {
  const imageArray = [Img1, Img2, Img3, Img4, Img5, Img6, Img7, Img8, Img9];

  // const relatedDates = [];

  const projects = [
    {
      title: "MEG Energy",
      firm: "Oil & Gas",
      image: Project_first, // Placeholder image URL
      link: "/portfolio_page/meg-energy/", // URL path or external link
    },
    {
      title: "Imperial Oil – Quarry Park",
      firm: "Oil & Gas",
      image: Project_second,
      link: "/portfolio_page/imperial-oil-quarry-park/",
    },
    {
      title: "Pembina Pipeline",
      firm: "Oil & Gas",
      image: Project_third,
      link: "/portfolio_page/cenovus-energy/",
    },
    {
      title: "Cenovus Energy",
      firm: "Oil & Gas",
      image: Project_four,
      link: "/portfolio_page/cenovus-energy/",
    },
  ];

  useDocumentMetaData({
    title: "Nexen Wellness - MidWest Group",
    description:
      "MidWest Group contributed to the Nexen Wellness Centre in Calgary, delivering innovative drywall, acoustic, and ceiling solutions for this LEED Silver-certified facility designed by DIALOG.",
    keywords:
      "Nexen Wellness, Calgary, MidWest Group, DIALOG, Cougar Contractors, drywall, acoustic panels, ceilings, LEED Silver, wellness centre",
    canonical: "https://www.midwest-group.com/portfolio_page/nexen-wellness/",
    author: "MidWest Group",
    ogTitle: "Nexen Wellness Centre - MidWest Group",
    ogDescription:
      "MidWest Group worked on the Nexen Wellness Centre, providing drywall partitions, acoustic solutions, and advanced ceiling systems for this LEED Silver-certified facility.",
    ogImage: "https://www.midwest-group.com/static/media/nexen_eight.a198a845f675b0ff48ed.jpg",
    ogUrl: "https://www.midwest-group.com/portfolio_page/nexen-wellness/",
    twitterTitle: "Nexen Wellness Centre - MidWest Group",
    twitterDescription:
      "MidWest Group supported the Nexen Wellness Centre with drywall, acoustic, and ceiling solutions, contributing to its LEED Silver certification.",
    twitterImage: "https://www.midwest-group.com/static/media/nexen_eight.a198a845f675b0ff48ed.jpg",
  });

  return (
    <>
      <div className="parent-div">
        <Container
          fixed
          className="parent-container"
          style={{ paddingLeft: "0px", paddingRight: "0px" }}
        >
          <Box>
            <Contentimages
              tab={"Calgary, Alberta"}
              heading={"Nexen Wellness"}
              imageArray={imageArray}
            >
              Nexen Wellness Centre is a state-of-the-art facility and an
              inspiring representation of their commitment to employee health.
              Design entity DIALOG excelled in creating a space that welcomes
              and motivates while maintaining careful consideration of acoustic
              performance.
              <br></br>
              <br></br>
              Working alongside Cougar Contractors, the MidWest team’s scope
              included standard drywall partitions, and other unique products
              and services, including:
              <br></br>
              <br></br>
              <ul style={{ paddingLeft: "15px", marginBottom: "0px" }}>
                <li>
                  Cutting and reusing salvaged ceiling tiles for wall insulation
                </li>
                <li>Installing a cement board suspended ceiling</li>
                <li>ModularArts® acoustic panels</li>
                <li>
                  Armstrong Axiom Knife Edge ceiling trim, including
                  sandblasting, radius, and custom finish
                </li>
                <li>Armstrong Techzone ceiling grid with Ultima tile</li>
                <li>Application of StarSilent acoustic plaster</li>
                <li>Layout and coordination for lighting and mechanical</li>
              </ul>
              <br></br>
              The project received a LEED Silver certification.
            </Contentimages>
            <Grid container paddingBottom={10}></Grid>

            <ProtfolioNavigation
              backUrl="/portfolio_page/bow-tower/"
              nextUrl="/portfolio_page/arcan-resources/"
            />
            <RelatedProjects projects={projects} />
          </Box>
        </Container>
      </div>
    </>
  );
};

export default Nexenwellness;
